/**
 *@author yudeping
 *单选控件
 */

import Component from '../../../lib/component';
import './radio-control.scss';
import template from './radio-control.html'
import WXtemplate from './radio-control.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';
let config={
    template:template,
    actions:{
        changeOption(res){
            if( this.data.dfield && res == this.data.dfield ){
                this.data.value = [];
                this.reload();
            }
        },
	    init(){
		    if(this.data.style && this.data.style.hs && this.data.style.hs=='s'){
			    this.el.find('.df-input-label').addClass('flexItem');
			    this.el.find('.radio-wrap').removeClass('height26');
			    this.el.find('.direction-wrap').addClass('line');
			    this.el.find('.df-input-radio-wrapper').css('top','8px');
		    }
	    },
	    iconCheck(){
		    if(this.data.is_view){
			    this.el.find('.df-input-radio').attr('disabled',true);
		    }else{
			    this.el.find('.df-input-radio').attr('disabled',false);
		    }
		    if(this.data.history){
			    this.el.find('.ui-history').css('visibility','visible').addClass('icon-fl');
		    }
		    if(!this.data.is_view && this.data.can_add_item){
			    this.el.find('.add-item').css('visibility','visible').addClass('icon-fl');
		    }
	    },
	    changeValue(event){
		    this.data.value=event.value;
			this.events.changeValue(this.data);
		    for(let obj of this.data.group){
			    if(obj.value==event.value){
				    obj['checked']=true;
			    }else{
				    obj['checked']=false;
			    }
		    }
		    this.reload();
	    }
    },
    binds:[
        {
            event: 'click',
            selector: '.ui-history',
            callback: function(){
                this.events.emitHistory(this.data);
            }
        },
        {
            event: 'click',
            selector: '.add-item',
            callback: function(){
                this.events.addItem(this.data)
            }
        },
        {
            event: 'click',
            selector: '.df-input-radio',
            callback: function(event){
               this.actions.changeValue(event);
            }
        }
    ],
    afterRender(){
    	this.actions.init();
    	this.actions.iconCheck();
    },
    beforeDestory(){
        this.el.off();
    }
}
let RadioControl = Component.extend(config)
export default RadioControl
let WXconfig={
	data:{controlHtml:WXtemplate},
	actions:Object.assign({},config.actions,{
		changeValue(event){
			this.data.value=event.value;
			for(let obj of this.data.group){
				if(obj.value==event.value){
					obj['checked']=true;
				}else{
					obj['checked']=false;
				}
			}
			this.reload();
		},
		createRadio(){
			let elLabel1 = `<label class="df-input-label">`;
			let elLabel2 = `</label>`
			let elWrapper1 = `<div class="df-input-radio-wrapper noprint" style="display: inline">`
			let elWrapper2 = `</div>`
			let elStatus = `<div class="df-input-radio-status"  style="display: inline"></div>`
			if(this.data.group){
				this.data.group.forEach(item => {
					if(item.checked){
						this.el.find('.direction-wrap').append(elLabel1+elWrapper1+elStatus+elWrapper2+`<input class="df-input-radio print" type="radio" value="${item.value}" readonly>`+item.label+elLabel2);
					}else{
						if(this.data.is_view){
							let dom=this.el.find('.direction-wrap').append(elLabel1+elWrapper1+elWrapper2+`<input class="df-input-radio print" type="radio" value="${item.value}" readonly>`+item.label+elLabel2);
							dom.find('.df-input-label:last-child').css('color','#ccc !important');
						}else{
							this.el.find('.direction-wrap').append(elLabel1+elWrapper1+elWrapper2+`<input class="df-input-radio print" type="radio" value="${item.value}" readonly>`+item.label+elLabel2);
						}
					}
				})
			}
			if(this.data.is_view){
				this.el.find('.df-input-radio').attr('disabled',true);
			}else{
				this.el.find('.df-input-radio').attr('disabled',false);
			}
		}
	}),
	binds:[config.binds[2]],
	afterRender(){
		this._super.afterRender();
		this.actions.createRadio();
		this.actions.init();
	}
}
let RadioWX=BaseControl.extend(WXconfig);
export {RadioWX}


// WEBPACK FOOTER //
// app/components/form/radio-control/radio-control.js